function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#00C4B5",
  fillOpacity: 0.9
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 29.7744,
  y: 16.5762,
  width: 2.33333,
  height: 18.6667,
  rx: 1,
  transform: "rotate(45 29.7744 16.5762)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 22.3506,
  width: 10.5,
  height: 2.33333,
  rx: 1,
  transform: "rotate(45 24 22.3506)",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 18.2256,
  y: 16.5762,
  width: 10.0681,
  height: 2.33333,
  rx: 1,
  transform: "rotate(45 18.2256 16.5762)",
  fill: "white"
});

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.87d4b3dd.svg";
export { ForwardRef as ReactComponent };